var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviewEnter = function SvgPreviewEnter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#preview_enter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm3.92 12.75L9.4 18.54a.99.99 0 0 1-1.41-.09.997.997 0 0 1 .08-1.41L13.76 12 8.07 6.96c-.41-.37-.45-1-.08-1.41.19-.22.47-.34.74-.34.24 0 .47.08.66.25l6.53 5.79c.21.19.34.46.34.75s-.12.56-.34.75Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "preview_enter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPreviewEnter;